import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SoccerHall } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class SoccerHallService extends InfrastructureService<SoccerHall> {
  protected readonly endpoint: string = '/SoccerHalls';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
